/**
 * @description Authentication Store Module
 * @author Fahid Mohammad
 */
import { predectivesearch_uri, chs_uri, custromer_uri, translation_uri   } from '../config';
import axios from 'axios';
const VueCookie = require('vue-cookie') // using require to avoid SSR rejection

export default {
    namespaced: true,
    state: {
        isLoggedIn:false,
        isLoading:false,
        token:"",
        firstname:"",
        lastname:"",
        email: ""
    },
    mutations:{
        addIsLoggedIn: (state, status) => {
            state.isLoggedIn = status
        },
        removeIsLoggedIn: (state) => {
            state.isLoggedIn = false
        },
        addLogin: (state, {status, token, firstname, lastname, email}) => {
            state.isLoggedIn = status
            state.token = token
            state.firstname = firstname
            state.lastname = lastname
            state.email = email
        },
        // setLanguage: (state, lang) => {
        //     state.currentLanguage = lang
        // },
        setLoading: (state, status) => {
            state.isLoading = status
        },
        setCustomerInfo: (state, customerData) => {
            state.customerData = customerData
        }
    },
    actions:{
        SET_ISLOGGEDIN({ commit }, status) {
            commit('addIsLoggedIn', { status })
        },
        // SET_CUST_LANGUAGE({ commit }, lang) {
        //     commit('setLanguage',  lang )
        // },
        async CUSTOMER_SIGNIN({ commit }, cust) {
            try {
              let url = chs_uri+'auth/customer/login';
              commit('setLoading', true)
              const options = {
                method: 'POST',
                data: cust,
                url,
              };
              let { data } = await axios(options);
              commit('setLoading', false)
              let status = false, token = null, firstname= null, lastname = null, email = null;
              if (data && data.status == 'SUCCESS'){
                status = true; token = data.data.token;
                firstname = data.data.user.firstname;
                lastname = data.data.user.lastname;
                email = data.data.user.email;
                //commit('setCustomerInfo', data.data.user)
                //  Commit to store
                commit('addLogin', { status, token, firstname, lastname, email })
                //  Set cookie
                VueCookie.set('token',token);
                VueCookie.set('firstname', firstname);
                VueCookie.set('lastname', lastname);
                VueCookie.set('email', email);
                return true
              }else{
                return false
              }
            } catch (e) {
            }
        },

        async CUSTOMER_REGISTER({ commit }, vObj) {
            try {
              let url =chs_uri+'auth/customer/register';
              commit('setLoading', true)
              const options = {
                method: 'POST',
                data: vObj.cust,
                url,
              };
              let { data } = await axios(options);
              commit('setLoading', false)
              let status = false, token = null, firstname= null, lastname = null, email = null;
              if (data && data.status == 'SUCCESS'){
                status = true; token = data.data.token;
                firstname = data.data.user.firstname;
                lastname = data.data.user.lastname;
                email = data.data.user.email;
                //  Commit to store
                commit('addLogin', { status, token, firstname, lastname, email })
                //  Set cookie
                VueCookie.set('token',token);
                VueCookie.set('firstname', firstname);
                VueCookie.set('lastname', lastname);
                VueCookie.set('email', email);
                return data
              }else{
                return data
              }
            } catch (e) {
            }
          },

        async CUSTOMER_LOGOUT({ commit }) {
            try {
              let url = chs_uri+'auth/customer/logout';
              const options = {
                method: 'POST',
                url,
              };
              let { data } = await axios(options);
              let status = false, token = null, firstname= null, lastname = null, email = null;
              //  Commit to store
              commit('addLogin', { status, token, firstname, lastname, email })
              // Delete Cookies
              VueCookie.delete('token');
              VueCookie.delete('firstname');
              VueCookie.delete('lastname');
              VueCookie.delete('email');
              //commit('setCustomerInfo', cData)
              return true;
            } catch (error) {
              if (error.response && error.response.status === 401) {
                throw new Error('Bad credentials')
              }
              throw error
            }
          },
        UPDATE_LOGIN({ commit }, {status, token, firstname, lastname, email}) {
            commit('addLogin', { status, token, firstname, lastname, email })
        }
    },
    getters:{
        getLoginStatus: state => {
            return state.isLoggedIn
        },
        getToken : state =>{
            return state.token
        },
        getCustomerInfo: state => {
            return state.customerData
        },
        getLang: state => {
            return state.currentLanguage
        }
    }
}


// WEBPACK FOOTER //
// src/store/authentication.js